/**
 * 企画回別商品一覧画面の企画回別商品一覧情報クラス
 *
 * @export PublishPlanGoodsCategoryListInfo
 * @class PublishPlanGoodsCategoryListInfo
 */
export class PublishPlanGoodsCategoryListInfo {
  constructor(
    public confirmFlg: string = '',
    public useNumPeople: string = '',
    public totalLineNum: string = '',
    public mediumSurfaceLineNum: string = '',
    public largeComaNum: string = '',
    public planResult: string = '',
    public supply: string = '',
    public gp: string = '',
    public budgetValueGPR: string = '',
    public publishPlanGoodsCategoryList: PublishPlanGoodsCategory[] = [],
  ) {}
}

export class PublishPlanGoodsCategory {
  // 忘れず注文商品ステータス 承認済み
  public static readonly REMEMBER_GOODS_STATUS_APPROVED = '2';

  constructor(
    public orderCode: string,
    public catalogId: string,
    public className: string,
    public middleClassName: string,
    public smallClassName: string,
    public goodsName: string,
    public goodsStandardName: string,
    public pcode: string,
    public itemCode: string,
    public janCode: string,
    public largeClassName: string,
    public payeeClientKanji: string,
    public ordrClientKanji: string,
    public applyTermEnd: string,
    public specialFeature: string,
    public folio: string,
    public edlp: string,
    public rememberGoods: string,
    public orderReceptionStartCatalog: string,
    public orderReceptionEndCatalog: string,
    public goodsMemo: string,
    public buyerComment: string,
    public coopFlg142: boolean,
    public coopFlg163: boolean,
    public coopFlg185: boolean,
    public coopFlg240: boolean,
    public coopFlg210: boolean,
    public coopFlg302: boolean,
    public coopFlg515: boolean,
    public coopFlg451: boolean,
    public coopEnabledFlg142: boolean,
    public coopEnabledFlg163: boolean,
    public coopEnabledFlg185: boolean,
    public coopEnabledFlg240: boolean,
    public coopEnabledFlg210: boolean,
    public coopEnabledFlg302: boolean,
    public coopEnabledFlg515: boolean,
    public coopEnabledFlg451: boolean,
    public pricePattern: string,
    public pricePromotion: string,
    public bargainMarkFlg: boolean,
    public komaPromotion: string,
    public promotionMark: string,
    public appearDiv: string,
    public orderNumQuotaCode: string,
    public orderNumQuotaName: string,
    public mediumWPublishFlg: boolean,
    public crossCode: string,
    public pCodeOfCross: string,
    public crossDecisionFlg: boolean,
    public wCrossFlg: boolean,
    public thisTimeSupplyPrice: string,
    public thisTimeCostPrice: string,
    public supplyPriceStandard: string,
    public supplyPriceSpecial1: string,
    public supplyPriceSpecial2: string,
    public costPriceStandard: string,
    public costPriceSpecial1: string,
    public costPriceSpecial2: string,
    public bundlePrice: string,
    public planNumAiPrediction: string,
    public planNum: string,
    public wCarryingFlg: boolean,
    public mainCoopCode: string,
    public piValue: string,
    public supplyBudget: string,
    public gpValue: string,
    public gprValue: string,
  ) {}

  static getPIValue(planNum: string, useNumPeople: string, planNumAiPrediction: string): string {
    // 計画数(修正後)÷利用人数予測×1000 ※計画数（修正後）が未入力の行は計画数（予測）を使用 ※計画数（修正後）・計画数（予測）どちらも未入力の場合は0を使用
    let piValue = 0;
    // 0除算対応
    if (useNumPeople === '0') {
      return String(piValue);
    }
    if (planNum) {
      piValue = (Number(planNum) / Number(useNumPeople)) * 1000;
    } else {
      if (planNumAiPrediction) {
        piValue = (Number(planNumAiPrediction) / Number(useNumPeople)) * 1000;
      }
    }
    return String(piValue);
  }

  static getSupplyBudget(thisTimeSupplyPrice: string, planNum: string, planNumAiPrediction: string): string {
    // 今回供給価×計画数(修正後)
    let supplyBudgetValue = 0;
    if (planNum) {
      supplyBudgetValue = Number(thisTimeSupplyPrice) * Number(planNum);
    } else {
      if (planNumAiPrediction) {
        supplyBudgetValue = Number(thisTimeSupplyPrice) * Number(planNumAiPrediction);
      }
    }
    return String(supplyBudgetValue);
  }

  static getGPValue(supplyBudget: string, planNum: string, thisTimeCostPrice: string, bundlePrice: string, planNumAiPrediction: string): string {
    // 供給高－（計画数(修正後)×今回仕入価×価格バンドル
    let gpValue = 0;
    if (planNum) {
      gpValue = Number(supplyBudget) - (Number(planNum) * Number(thisTimeCostPrice) * Number(bundlePrice));
    } else {
      if (planNumAiPrediction) {
        gpValue = Number(supplyBudget) - (Number(planNumAiPrediction) * Number(thisTimeCostPrice) * Number(bundlePrice));
      }
    }
    // 小数点以下切り捨て
    return String(Math.floor(gpValue));
  }

  static getGPRValue(gpValue: string, supplyBudget: string): string {
     // GP高÷供給高×100
     if (gpValue === '0' || supplyBudget === '0') {
      return '0';
     }
    return String((Number(gpValue) / Number(supplyBudget)) * 100);
  }

  get isRememberGoods() {
    return (
      PublishPlanGoodsCategory.REMEMBER_GOODS_STATUS_APPROVED ===
        this.rememberGoods &&
      this.orderReceptionStartCatalog <= this.catalogId &&
      this.orderReceptionEndCatalog >= this.catalogId
    );
  }
}
